import { inject, singleton } from "tsyringe";
import { AdsContext } from "./ads-context";

export enum Platforms {
  F2 = "f2",
  FUTHEAD = "futhead",
  MUTHEAD = "muthead",
  GAMESPOT = "gamespot",
  COMICVINE = "comicvine",
  GAMEFAQS = "gamefaqs",
  METACRITIC = "metacritic",
  METACRITIC_NEUTRON = "metacritic-neutron",
  TVGUIDE = "tvguide",
  TVGUIDE_MTC = "tvguide-mtc",
  GIANTBOMB = "giantbomb",
  FANATICAL = "fanatical",
  FANDOMDESKTOP = "fandomdesktop",
  FANDOMMOBILE = "fandommobile",
}

@singleton()
export class Platform {
  constructor(@inject(AdsContext) private readonly adsContext: AdsContext) {}

  get(): Platforms {
    const adsContext = this.adsContext.get();
    const platform = (adsContext?.platform ?? adsContext?.app) as Platforms;

    if (!platform) {
      return this.detectPlatform();
    }

    return platform;
  }

  private detectPlatform(): Platforms {
    // Check for MediaWiki
    if (
      window.mw !== undefined &&
      window.ads?.context?.opts?.platformName !== undefined
    ) {
      return window.ads.context.opts.platformName as Platforms;
    }

    return this.checkHostname();
  }

  private checkHostname(): Platforms {
    const { hostname, pathname } = window.location;

    switch (true) {
      /// www.fandom.com
      case hostname.includes("fandom"):
        return Platforms.F2;
      // futhead.com
      case hostname.includes("futhead"):
        return Platforms.FUTHEAD;
      // muthead.com
      case hostname.includes("muthead"):
        return Platforms.MUTHEAD;
      // comicvine.gamespot.com, gamefaqs.gamespot.com, gamespot.com
      case hostname.includes("gamespot"):
        return hostname.includes("comicvine")
          ? Platforms.COMICVINE
          : hostname.includes("gamefaqs")
            ? Platforms.GAMEFAQS
            : Platforms.GAMESPOT;
      // metcritic.com, metacritic.com/news
      case hostname.includes("metacritic"):
        return pathname.includes("news")
          ? Platforms.METACRITIC_NEUTRON
          : Platforms.METACRITIC;
      // tvguide.com
      case hostname.includes("tvguide"):
        return Platforms.TVGUIDE;
      case hostname.includes("giantbomb"):
        return Platforms.GIANTBOMB;
      case hostname.includes("fanatical"):
        return Platforms.FANATICAL;
      default:
        return Platforms.FANDOMDESKTOP;
    }
  }
}
